import { makeAutoObservable } from 'mobx'
import type { IChatbotFollowUpAssertiveness, ChatbotAutoFollowUp } from 'entities/Chatbot'

export class AutoFollowUpSectionStore {
  constructor(private readonly _autoFollowUp: ChatbotAutoFollowUp) {
    makeAutoObservable(this)
  }

  get enabled() {
    return this._autoFollowUp.enabled
  }

  get followUpWindow() {
    return this._autoFollowUp.followUpWindow
  }

  get assertiveness() {
    return this._autoFollowUp.assertiveness
  }

  get sessionLifetime() {
    return this._autoFollowUp.sessionLifetime
  }

  setEnabled = (value: boolean) => this._autoFollowUp.setEnabled(value)

  setFollowUpWindow = (value: number) => this._autoFollowUp.setFollowUpWindow(value)

  setAssertiveness = (value: IChatbotFollowUpAssertiveness) =>
    this._autoFollowUp.setAssertiveness(value)

  setSessionLifetime = (value: number) => this._autoFollowUp.setSessionLifetime(value)
}
